import React, {useContext} from 'react';
import {UserContext} from "@context/UserContext";

const WelcomeDashboardWidgetUSA = () => {
    const { user } = useContext(UserContext);

    return (
        <h1>Welcome back to Cambridge Math, {user.firstName}!</h1>
    )
}

export default WelcomeDashboardWidgetUSA;